import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconDownload2Group: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        fill={fillColor}
        d="M12 15.575c-.1333 0-.2583-.0208-.375-.0625-.1167-.0417-.225-.1125-.325-.2125l-3.6-3.6c-.2-.2-.2958-.4333-.2875-.7.0083-.2667.1042-.5.2875-.7.2-.2.4375-.3042.7125-.3125.275-.0083.5125.0875.7125.2875l1.875 1.875v-7.15c0-.2833.0958-.5208.2875-.7125.1917-.1917.4292-.2875.7125-.2875.2833 0 .5208.0958.7125.2875.1917.1917.2875.4292.2875.7125v7.15l1.875-1.875c.2-.2.4375-.2958.7125-.2875.275.0083.5125.1125.7125.3125.1833.2.2792.4333.2875.7.0083.2667-.0875.5-.2875.7l-3.6 3.6c-.1.1-.2083.1708-.325.2125-.1167.0417-.2417.0625-.375.0625zm-6 4.425c-.55 0-1.0208-.1958-1.4125-.5875-.3917-.3917-.5875-.8625-.5875-1.4125v-2c0-.2833.0958-.5208.2875-.7125.1917-.1917.4292-.2875.7125-.2875.2833 0 .5208.0958.7125.2875.1917.1917.2875.4292.2875.7125v2h12v-2c0-.2833.0958-.5208.2875-.7125.1917-.1917.4292-.2875.7125-.2875.2833 0 .5208.0958.7125.2875.1917.1917.2875.4292.2875.7125v2c0 .55-.1958 1.0208-.5875 1.4125-.3917.3917-.8625.5875-1.4125.5875h-12z"
      />
    </g>
  );
};

export const IconDownload2Svg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconDownload2Group {...props} />
    </svg>
  );
};
